import AddTimesTab from "./sub_tabs/AddTimesTab";
import ViewTimesTab from "./sub_tabs/ViewTimesTab";

const timesAndLocationsRouter = {

  times: 
  {
    title: 'List',
    element: <ViewTimesTab />
  },

  add_time: 
  {
    title: 'Add Times',
    element: <AddTimesTab />
  }

}

export default timesAndLocationsRouter;